import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';
import {Shipment} from '../services/shipment';
import {ShipmentRoute} from '../services/shipment-route';
import {BranchesService} from '../services/branches.service';
import {ShipmentDriversService} from '../services/shipment-drivers.service';
import * as _ from 'lodash';
import {ShippingSystemTableComponent} from '../shipping-system-table/shipping-system-table.component';
import {OrderLineStatus} from '../services/shipment-product-line';
import {ShipmentsService} from '../services/shipments.service';
import {Options} from 'sortablejs';

declare let NProgress: any;

@Component({
    providers: [BranchesService, ShipmentDriversService],
    selector: 'app-shipping-system-sorter',
    templateUrl: './shipping-system-sorter.component.html',
    styleUrls: ['./shipping-system-sorter.component.scss'],
})
export class ShippingSystemSorterComponent implements OnInit, OnChanges {

    @Output() shipmentsChanged = new EventEmitter<any>();
    @Output() routeChanged = new EventEmitter<any>();
    @Input() shipments: Shipment[];
    @Input() options: any;
    @Input() shipmentRoutes: ShipmentRoute[];
    @Input() branch: string[];
    @Input() driver;
    @Input() oneDay: boolean;
    @Input() expandOrderLines: boolean;
    @Input() sortfield = 'sorting';

    @ViewChildren(ShippingSystemTableComponent) viewChildren!: QueryList<ShippingSystemTableComponent>;

    collaps: any = {};

    routes = {};
    problemRoutes = {};

    problemShipments = [];

    constructor(public branchesService: BranchesService,
                public shipmentsService: ShipmentsService,
                public shipmentDriversService: ShipmentDriversService) {
    }

    ngOnInit() {
        this.loadCollapseState();
    }

    loadCollapseState() {
        try {
            const saved = localStorage.getItem('shipping-system-collaps');
            if (saved) {
                this.collaps = JSON.parse(saved) || {};
            }
        } catch (e) {
            this.collaps = {};
        }
    }

    saveCollapseState() {
        try {
            localStorage.setItem('shipping-system-collaps', JSON.stringify(this.collaps));
        } catch (e) {
            console.error('Failed to save collapse state to localStorage', e);
        }
    }

    ngOnChanges(changes) {
        this.setRoutes();
        this.getParkingLot()
    }

    getParkingLot() {
        this.shipmentRoutes.filter((item) => {
            return this.shouldShowSepcialRoute(item, this.branch);
        }).forEach((route) => {
            this.problemRoutes[route.id] = [];
            this.shipmentsService.getShipments(null, {
                statusFilter: this.options.statusFilter,
                all: true,
                routeId: route.id,
                isSearching: false,
                branch: this.branch,
                combineEvents: true,
            }).then(response => {
                this.problemRoutes[route.id] = response.results;
            });
        });
    }



    getBranchName(shorthand: string[]) {
        if (shorthand && shorthand.length > 0) {
        return this.branchesService.branches[shorthand[0]];
        }
    }

    setRoutes() {
        this.routes['null'] = this.shipments.filter(shipment => shipment.shipment_route_id === null);

        for (const shipmentRoute of this.shipmentRoutes) {
            this.routes[shipmentRoute.id] = this.shipments.filter(e => e.shipment_route_id === shipmentRoute.id);
            const key = shipmentRoute.branch + '-' + shipmentRoute.driver;
            if (this.collaps[key] === undefined) {
                this.collaps[key] = false;
            }
        }

        if (this.expandOrderLines) {
            this.problemShipments = this.shipments.filter((item) => {
                if (this.expandOrderLines) {
                    const status = item.getProductLinesStatus()
                    if (status === OrderLineStatus.Ok) {
                        return false
                    }
                    return true;
                } else {
                    return true;
                }
            });
        }
    }

    provideDefaultShipments(): Shipment[] {
        if (this.oneDay) {
            return this.routes['null']
        } else if (this.expandOrderLines) {
            return this.problemShipments
        } else {
            return this.shipments;
        }
    }

    toggleRouteCollapse(shipmentRoute: ShipmentRoute) {
        const key = shipmentRoute.branch + '-' + shipmentRoute.driver;
        this.collaps[key] = !this.collaps[key];
        this.saveCollapseState();
    }

    toggleCollapse(hide = true) {
        _.forOwn(this.collaps, (value, key) => {
            this.collaps[key] = hide;
        });
        this.saveCollapseState();
    }

    areAllCollapsed() {
        return _.every(this.collaps, value => value);
    }

        shouldShowSepcialRoute(shipmentRoute, branch: string[]) {
        if (shipmentRoute.is_global && this.branch.indexOf(shipmentRoute.branch) !== -1) {
            return true;
        }

        return false;
    }

    /**
     *
     * @param shipmentRoute
     * @param processed
     */
    shouldShowRoute(shipmentRoute: ShipmentRoute, processed: boolean) {

        if (!shipmentRoute.trip) {
            return false;
        }

        if (!this.branch) {
            return true;
        }

        if (Array.isArray(this.branch) && this.branch.length === 1) {
            const singleBranch = this.branch[0];
            if (!this.driver) {
                if (processed) {
                    return (shipmentRoute.trip === '0') && !shipmentRoute.is_global && singleBranch === shipmentRoute.branch;
                } else {
                    return shipmentRoute.trip !== '0' && !shipmentRoute.is_global && singleBranch === shipmentRoute.branch;
                }
            } else {
                return (singleBranch + '-' + this.driver.driver) === (shipmentRoute.branch + '-' + shipmentRoute.driver);
            }
        }
    }

    driverShipments(branch: string, driver: string): number {
        const branchDriver = branch + '-' + driver;

        let shipments = 0;
        const shipmentRoutes = this.shipmentRoutes.filter(e => e.branch + '-' + e.driver === branchDriver);

        for (const shipmentRoute of shipmentRoutes) {
            shipments += this.routes[shipmentRoute.id].length;
        }

        return shipments;
    }

    shipmentsChangedCallback() {
        this.shipmentsChanged.emit();
    }

    routeChangedCallback($event) {
        this.routeChanged.emit($event);
    }
}
